import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useStrings } from '../i18n';

export default function Profile() {
  const { isAuthenticated, userInfo, loadingUser } = useAuth();
  const strings = useStrings();

  // Show loading while auth state is initializing
  if (loadingUser) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <span className="text-sm md:text-base text-bodyText">{strings.profile.loadingProfile}</span>
      </div>
    );
  }

  // Redirect if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="w-full max-w-3xl mx-auto px-4 md:px-6 mt-12 md:mt-20 p-4 md:p-6 bg-cardBg rounded shadow-md">
      <h2 className="text-2xl md:text-3xl font-semibold mb-4">{strings.profile.header}</h2>
      {userInfo ? (
        <div className="space-y-2 md:space-y-3 text-sm md:text-base">
          {userInfo.displayName && <p><strong>{strings.profile.labels.name}:</strong> {userInfo.displayName}</p>}
          <p><strong>{strings.profile.labels.email}:</strong> {userInfo.email}</p>
          {userInfo.photoURL && (
            <img
              src={userInfo.photoURL}
              alt="Profile"
              className="w-16 h-16 rounded-full mt-2"
            />
          )}
        </div>
      ) : (
        <p className="text-sm md:text-base">{strings.profile.loadingUserInfo}</p>
      )}
    </div>
  );
}
